import React from 'react';
import { useTranslations } from '@transifex/react';
const TranslationProvider = ({ children }) => {
    useTranslations('layout');
    return React.createElement(React.Fragment, null, children);
};
export default TranslationProvider;
//# sourceMappingURL=TranslationProvider.js.map